import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "80%",
    "margin": "auto"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
  const _component_van_field = _resolveComponent("van-field");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("b", null, _toDisplayString($props.labelText), 1), _createVNode(_component_van_field, {
    modelValue: $data.tel,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.tel = $event),
    label: "手機號碼",
    placeholder: $props.placeholder,
    ref: "phoneInput",
    style: {
      "border": "1px solid #633b5b",
      "border-radius": "40px"
    },
    maxlength: 11,
    rules: $data.phoneRules
  }, {
    label: _withCtx(() => [_createVNode(_component_van_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
        modelValue: $data.areaCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.areaCode = $event),
        options: $data.options,
        onChange: $options.onAreaCodeChange,
        direction: "down"
      }, null, 8, ["modelValue", "options", "onChange"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "placeholder", "rules"])]);
}